<template>
  <div class="base-search-condition-modal">
    <el-row class="search-box">
      <div class="search-input">
        <el-select
            slot="reference"
            v-model="selectTemplateId"
            :class="'selectAndCreate'"
            :no-match-text="'No matching data'"
            :no-data-text="'No data'"
            @change="onChange">
          <el-option v-for="item in templateOptions"
              :key="item['value']"
              :label="item['name']"
              :value="item['value']">
            <slot :item="item" />
          </el-option>
        </el-select>
        <el-button :disabled="createDisable"
            @click="fileCreate">
          作成
        </el-button>
      </div>
      <div>
        <el-button
            @click="clear">
          条件クリア
        </el-button>
      </div>
      <div>
        <el-button
            @click="getLatest">
          最新情報取得
        </el-button>
      </div>
    </el-row>

    <el-row class="base-search-condition">
      <BaseSearchCondition
          v-if="isKeyowordCondition"
          :item="keyowordCondition"
          :is-keyword="true"
          :name="'keyoword'"
          :store-path="storePath" />
      <BaseSearchCondition
          v-for="(condition, index) in dispCondition"
          :key="index"
          :item="condition"
          :name="index"
          :store-path="storePath" />
      <div class="layoutAdjustment" />
      <div class="layoutAdjustment" />
      <div class="layoutAdjustment" />
      <div class="layoutAdjustment" />
    </el-row>
  </div>
</template>

<style scoped>
  .layoutAdjustment{
    width: 448px;
    padding: 0px;
  }
  .selectAndCreate{
    display: inline-block;
    width: 100%;
  }
  .search-input .el-button {
      top: 0;
  }
</style>

<script>
import { mapState } from 'vuex'

import _ from 'lodash'
import moment from 'moment'
import common from '@/utils/common'
import * as query from '@/queries/download'
import * as config from '@/config' // TODO 削除
import BaseSearchCondition from '@/components/organisms/BaseSearchCondition'

export default {
  name: 'DownloadConditionModal',
  components: {
    BaseSearchCondition
  },
  props: {
    // localstorage key
    saveKey: {
      type: String,
      required: true
    },
    // store パス
    storePath: {
      type: String,
      required: true
    }
  },
  provide () {
    return {
      parentValidator: this.$validator
    }
  },
  data () {
    return {
      dialogVisible: false,
      selectTemplateId: null,
      createDisable: true
    }
  },
  computed: {
    ...mapState({
      templateInfo: (state) => state.Download.templateInfo,
      conditions: (state) => state.Download.searchConditions,
      searchKey: (state) => state.Download.searchKey,
      passedConditions: (state) => state.Download.passedConditions,
      passedTemplateKey: (state) => state.Download.passedTemplateKey
    }),
    disableAddConditions () {
      return this.conditions == null || Object.keys(this.conditions).length === 0
    },
    templateOptions () {
      return this.templateInfo.map((template) => { return { value: template.id, name: template.displayValue } })
    },
    dispCondition () {
      const returnValue = _.cloneDeep(this.conditions)
      delete returnValue.keyword
      return returnValue
    },
    keyowordCondition () {
      return _.get(this.conditions, 'keyword', null)
    },
    isKeyowordCondition () {
      return _.get(this.conditions, 'keyword', null) != null
    }
  },
  async created () {
    this.$loadingService.show()
    try {
      // テンプレート情報取得
      await this.getTemplateData()

      // 一覧から遷移してきた場合、テンプレートの指定と検索条件の復元を行う
      if (this.passedTemplateKey) {
        const targetTemplate = this.templateInfo.find((template) => template.searchConditionRefKey === this.passedTemplateKey)
        this.selectTemplateId = targetTemplate.id
        this.onChange(this.selectTemplateId)
        this.$store.dispatch({
          type: 'set',
          states: {
            'Download/passedTemplateKey': null
          }
        })
      }

      if (this.passedConditions) {
        const resultCondition = _.cloneDeep(this.conditions)
        Object.keys(this.passedConditions).forEach((key) => {
          const targetCondition = _.get(resultCondition, key, null)
          const passedCondition = _.get(this.passedConditions, key, null)
          if (targetCondition) {
            targetCondition.value = passedCondition.value
            if (passedCondition.isAndSearch) {
              targetCondition.isAndSearch = passedCondition.isAndSearch
            }
          }
        })
        this.$store.dispatch({
          type: 'set',
          states: {
            'Download/searchConditions': resultCondition,
            'Download/passedConditions': null
          }
        })
      }

    } catch (error) {
      this.$notify.error({ error: error })
      throw error
    } finally {
      this.$loadingService.close()
    }
  },
  methods: {
    modalOpen: function () {
      this.dialogVisible = true
    },
    modalClose: function () {
      this.$refs.searchModal.hide()
    },
    modalClear: function () {
      this.allDispChange(false)
    },
    // 全選択
    modalSelect: function () {
      this.allDispChange(true)
    },
    /**
     * 検索条件の display プロパティを更新します。
     * @param {Boolean} isShow 更新する値
     */
    allDispChange: function (isShow) {
      Object.keys(this.conditions).forEach(function (key) {
        this.$store.dispatch({
          type: 'setValue',
          states: {
            target: this.conditions[key],
            key: 'display',
            value: isShow
          }
        })
      }, this)
    },
    // ファイル作成処理を実行します。
    fileCreate: async function () {
      try {
        if (!await this.$validator.validate()) {
          return
        }
        this.$loadingService.show()

        const apiConditions = this.getConditions()

        // ダウンロードAPI呼び出し
        const url = config.DOWNLOAD
        const method = 'post'
        await common.apiAxios(url, {
          method,
          data: { downloadTemplateId: this.selectTemplateId, conditions: apiConditions }
        })

        // 親の再描画イベントを呼ぶ
        this.$emit('getLatest')
      } catch (error) {
        this.$notify.error({ error: error })
        throw error
      } finally {
        this.$loadingService.close()
      }
    },

    clear: async function () {
      Object.keys(this.conditions).forEach(key => {
        switch (this.conditions[key]['type']) {
          case 'MultiSelector':
          case 'NumberRange':
            this.conditions[key]['value'] = []
            break
          default :
            this.conditions[key]['value'] = ''
            break
        }
      })

      setTimeout(() => {
        this.$validator.validate()
      }, 100)
    },
    getLatest: async function () {
      // 親の再描画イベントを呼ぶ
      this.$emit('getLatest')
    },
    async getTemplateData () {
      if (!this.templateInfo || !this.templateInfo.length > 0) {
        const res = await common.postGraphQl(query.GRAPH_QL_QUERY_DOWNLOAD_TEMPLATE)
        const allOptions = common.getValueByPath(res.data, 'data.downloadTemplate')
        this.$store.dispatch({
          type: 'set',
          states: {
            'Download/templateInfo': allOptions.filter((option) => {
              return !this.$isFunctionDisabled(option.permissionConfigRefKey || 'not exists permission key') // 「not exists permission key」は存在しない権限キー
            })
          }
        })
      }
      // 一つ目のテンプレートを自動選択する
      if (this.templateInfo && this.templateInfo.length > 0) {
        this.selectTemplateId = this.templateInfo[0].id
        this.createDisable = false

        const searchKey = this.templateInfo.find(temp => temp.id === this.selectTemplateId).searchConditionRefKey
        this.$store.dispatch({
          type: 'set',
          states: { 'Download/searchKey': searchKey }
        })

        // 検索条件の設定
        this.setConditions(this.templateInfo[0].searchConditionRefKey)
      } else {
        this.createDisable = true
      }
    },
    onChange (event) {
      const searchKey = this.templateInfo.find(temp => temp.id === event).searchConditionRefKey
      this.$store.dispatch({
        type: 'set',
        states: { 'Download/searchKey': searchKey }
      })
      // 検索条件の設定
      this.setConditions(searchKey)
    },
    setConditions (searchKey) {
      const searchCondition = this.$store.state.convertedSearchConditions[searchKey]
      this.$store.dispatch({
        type: 'set',
        states: { 'Download/searchConditions': searchCondition }
      })
      this.modalSelect()
    },
    createQueryConditions () {
      let condition = {}
      // 検索パネルを取得
      _.forEach(this.conditions, (v, k) => {
        if (v.value.length > 0) {
          switch (v.type) {
            case 'MultiSelector':
              if (v.valueType === 1) {
                condition[k] = v.value.map(v => Number(v))
              } else {
                condition[k] = v.value
              }
              break
            case 'Date':
              condition[`${k}From`] = v.value[0]
              condition[`${k}To`] = moment(v.value[1]).add(1, 'd').utc().format()
              break
            case 'DateTime':
              condition[`${k}From`] = v.value[0]
              condition[`${k}To`] = moment(v.value[1]).add(1, 's').utc().format()
              break
            case 'NumberRange':
              if (v.value[0]) {
                // graphQLの整数型の最大値が「2の31乗-1」であり、正常に渡せないためString型で渡す
                condition[`${k}From`] = String(v.value[0])
              }
              if (v.value[1]) {
                // graphQLの整数型の最大値が「2の31乗-1」であり、正常に渡せないためString型で渡す
                condition[`${k}To`] = String(v.value[1])
              }
              break
            default:
              condition[k] = v.value
          }
        }
      })
      return condition
    },
    // 条件の値を取得
    getConditions () {
      const conditions = this.conditions
      let condition = {}

      // 検索パネルを取得
      _.forEach(conditions, (v, k) => {
        if (v.display && v.value.length > 0) {
          // AND検索対応
          // 検索キーワードを取得
          if (k === 'keyword') {
            condition.keyword = (v.isAndSearch ? '& ' : '') + v.value
          } else if (v.isAttribute) {
            const workCondition = {}
            workCondition.key = k
            switch (v.type) {
              case 'MultiSelector':
                if (v.valueType === 1) {
                  workCondition.value = v.value.map(v => Number(v))
                } else {
                  workCondition.value = v.value
                }
                break
              case 'Date':
                condition.From = v.value[0]
                condition.To = moment(v.value[1]).add(1, 'd').utc().format()
                break
              case 'DateTime':
                condition.From = v.value[0]
                condition.To = moment(v.value[1]).add(1, 's').utc().format()
                break
              case 'NumberRange':
                if (v.value[0]) {
                  // graphQLの整数型の最大値が「2の31乗-1」であり、正常に渡せないためString型で渡す
                  condition.From = String(v.value[0])
                }
                if (v.value[1]) {
                  // graphQLの整数型の最大値が「2の31乗-1」であり、正常に渡せないためString型で渡す
                  condition.To = String(v.value[1])
                }
                break
              default:
                workCondition.value = v.value
            }
            if (condition.xAttribute == null) {
              condition.xAttribute = {
                searchKey: this.searchKey,
                conditionValue: [workCondition]
              }
            } else {
              const tempAttribute = condition.xAttribute
              tempAttribute.conditionValue.push(workCondition)
              condition.xAttribute = tempAttribute
            }
          } else {
            switch (v.type) {
              case 'MultiSelector':
                if (v.valueType === 1) {
                  condition[k] = v.value.map(v => Number(v))
                } else {
                  condition[k] = v.value
                }
                break
              case 'Date':
                condition[`${k}From`] = v.value[0]
                condition[`${k}To`] = moment(v.value[1]).add(1, 'd').utc().format()
                break
              case 'DateTime':
                condition[`${k}From`] = v.value[0]
                condition[`${k}To`] = moment(v.value[1]).add(1, 's').utc().format()
                break
              case 'NumberRange':
                if (v.value[0]) {
                  // graphQLの整数型の最大値が「2の31乗-1」であり、正常に渡せないためString型で渡す
                  condition[`${k}From`] = String(v.value[0])
                }
                if (v.value[1]) {
                  // graphQLの整数型の最大値が「2の31乗-1」であり、正常に渡せないためString型で渡す
                  condition[`${k}To`] = String(v.value[1])
                }
                break
              default:
                condition[k] = v.value
            }
          }
        }
      })
      return condition
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/upload_download/download/DownloadConditionModal.vue